import { useQuery } from '@tanstack/react-query';

import { weatherApi } from 'api/weather';

export const WEATHER_REPORT_OPTIONS_QUERY_KEY = 'weatherReportOptions';

export const weatherReportOptionsQueryKeys = {
    all: [WEATHER_REPORT_OPTIONS_QUERY_KEY],
    options: () => [...weatherReportOptionsQueryKeys.all, 'options'],
};

/**
 * Fetches autocomplete options for the weather report request form.
 *
 * @param {Omit<import('@tanstack/react-query').UseQueryOptions<Object, Error>, 'queryKey' | 'queryFn'>} [queryOptions={]}
 * @returns {import('@tanstack/react-query').UseQueryResult<{orderSource: Array, deliveryType: Array, reportType: Array}, Error>}
 */
export function useWeatherReportOptionsQuery(queryOptions = {}) {
    return useQuery({
        queryKey: weatherReportOptionsQueryKeys.options(),
        queryFn: async () => {
            const response = await weatherApi.getReportOptions();
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch weather report options');
            }
            return response.data?.reportOptions ?? {};
        },
        staleTime: 15 * 60_000,
        gcTime: 30 * 60_000,
        ...queryOptions,
    });
}
